import React, { useState } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap"
import toastr from "toastr"
import apiURl from "url"

const ParentCategoryModal = ({ isOpen, toggle, onSave }) => {
  const [categoryName, setCategoryName] = useState("")

  const handleSave = async e => {
    e.preventDefault()
    if (!categoryName.trim()) {
      toastr.error("Category Name is required")
      return
    }

    try {
      const response = await fetch(`${apiURl}/api/categories/add-parent`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: categoryName }),
      })
      const json = await response.json()

      if (response.ok) {
        toastr.success("Parent Category added!")
        setCategoryName("")
        onSave()
        toggle()
      } else {
        toastr.error(json.message || "Failed to add parent category")
      }
    } catch (err) {
      console.error("Save Error:", err)
      toastr.error("Failed to add parent category")
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <Form onSubmit={handleSave}>
        <ModalHeader toggle={toggle}>Add Parent Category</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Category Name *</Label>
            <Input
              type="text"
              value={categoryName}
              onChange={e => setCategoryName(e.target.value)}
              placeholder="Enter category name"
              required
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button color="primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  )
}

export default ParentCategoryModal
